/* Founders Studio v3: stat count up, product card image flip with a how to hint, product gallery that follows each image's shape. Safe in Instagram and Facebook browsers. */
(function(){
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOUCH = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var HTML = document.documentElement;
  function ss(k, v){ try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch(e){ return null; } }
  if (ss('x-scrubbed')) HTML.classList.add('x-scrubbed');
  function scrubbed(){ if (!HTML.classList.contains('x-scrubbed')){ HTML.classList.add('x-scrubbed'); ss('x-scrubbed', '1'); } }

  function counters(){
    var els = [].slice.call(document.querySelectorAll('.x-rec-t b, [data-x-count]'));
    els.forEach(function(el){
      if (el.__xc) return; el.__xc = 1;
      var txt = (el.textContent || '').trim();
      var m = txt.match(/^([^0-9]*)([0-9][0-9,]*\.?[0-9]*)(.*)$/);
      if (!m) return;
      var pre = m[1], raw = m[2], suf = m[3];
      var commas = raw.indexOf(',') > -1;
      var dec = (raw.split('.')[1] || '').length;
      var end = parseFloat(raw.replace(/,/g, ''));
      if (!isFinite(end) || RM || !('IntersectionObserver' in window)) return;
      /* small short forms like $1M+ count in tenths so the climb reads, then land on the original text */
      if (/^[KMB]/i.test(suf) && end < 10 && dec === 0) dec = 1;
      function fmt(v){
        var s = v.toFixed(dec);
        if (commas){ var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); }
        return pre + s + suf;
      }
      el.style.fontVariantNumeric = 'tabular-nums';
      el.textContent = fmt(0);
      var started = false;
      function run(){
        if (started) return; started = true;
        if (document.hidden){ el.textContent = txt; return; }
        var t0 = null, dur = 1700;
        function step(t){
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(end * e);
          if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
        }
        requestAnimationFrame(step);
      }
      var io = new IntersectionObserver(function(en){
        en.forEach(function(x){ if (x.isIntersecting){ run(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(el);
      /* failsafe: if the tile is on screen and nothing ran, finish it */
      setTimeout(function(){
        if (started) return;
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) run();
      }, 2500);
    });
  }

  /* Product cards: hover or swipe moves through the images. A small pill shows how, until the shopper has tried it once. */
  function cards(root){
    [].slice.call((root || document).querySelectorAll('[data-x-flip]')).forEach(function(fig){
      if (fig.__xf) return; fig.__xf = 1;
      var imgs = [].slice.call(fig.querySelectorAll('.x-pc-i')), dots = [].slice.call(fig.querySelectorAll('.x-pc-dots i'));
      var n = imgs.length, cur = 0;
      if (n < 2) return;
      var hint = document.createElement('span');
      hint.className = 'x-pc-hint'; hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<i></i>' + (TOUCH ? 'Swipe for more' : 'Glide across for more');
      fig.appendChild(hint);
      function show(i, user){
        i = (i + n) % n; if (i === cur) return;
        imgs[cur].classList.remove('on'); if (dots[cur]) dots[cur].classList.remove('on');
        cur = i;
        imgs[cur].classList.add('on'); if (dots[cur]) dots[cur].classList.add('on');
        if (user) scrubbed();
      }
      fig.__show = show; fig.__n = n;
      fig.addEventListener('mousemove', function(e){
        var r = fig.getBoundingClientRect();
        show(Math.min(n - 1, Math.max(0, Math.floor((e.clientX - r.left) / r.width * n))), true);
      });
      fig.addEventListener('mouseleave', function(){ show(0); });
      var x0 = null, y0 = null, swiped = false;
      fig.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swiped = false; }, { passive: true });
      fig.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)){ swiped = true; fig.classList.add('is-touched'); show(cur + (dx < 0 ? 1 : -1), true); }
        x0 = null;
      }, { passive: true });
      var a = fig.closest('a');
      if (a) a.addEventListener('click', function(e){ if (swiped){ e.preventDefault(); swiped = false; } });
    });
  }

  /* The first card that comes into view plays a short demo once per visit: the pill shows and the images step across and back. */
  function demo(){
    if (RM || HTML.classList.contains('x-scrubbed') || !('IntersectionObserver' in window)) return;
    var figs = [].slice.call(document.querySelectorAll('[data-x-flip]')).filter(function(f){ return f.__show; });
    if (!figs.length) return;
    var done = false;
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){
        if (done || !x.isIntersecting) return;
        done = true; io.disconnect();
        var fig = x.target, n = fig.__n, k = 0, steps = [1, Math.min(2, n - 1), 1, 0];
        fig.classList.add('is-demo');
        setTimeout(function(){
          var t = setInterval(function(){
            if (k >= steps.length || HTML.classList.contains('x-scrubbed')){
              clearInterval(t); fig.__show(0);
              setTimeout(function(){ fig.classList.remove('is-demo'); }, 1400);
              return;
            }
            fig.__show(steps[k++]);
          }, 800);
        }, 700);
      });
    }, { threshold: 0.6 });
    figs.forEach(function(f){ io.observe(f); });
  }

  /* Product gallery: the stage takes the shape of the image or video showing, and only the showing video plays. */
  function gallery(){
    [].slice.call(document.querySelectorAll('[data-x-gal]')).forEach(function(g){
      if (g.__xg) return; g.__xg = 1;
      var st = g.querySelector('.hb-stage'); if (!st) return;
      var sl = [].slice.call(g.querySelectorAll('[data-x-sl]'));
      function sync(){
        sl.forEach(function(s){
          var v = s.querySelector('video'), on = s.classList.contains('on');
          if (on){
            var a = s.style.getPropertyValue('--x-ar'); if (a) st.style.setProperty('--x-ar', a);
            if (v){ try { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function(){}); } catch(e){} }
          } else if (v){ try { v.pause(); } catch(e){} }
        });
      }
      sl.forEach(function(s){
        var im = s.querySelector('img');
        if (!im) return;
        var fix = function(){ if (im.naturalWidth && im.naturalHeight){ s.style.setProperty('--x-ar', (im.naturalWidth / im.naturalHeight).toFixed(4)); if (s.classList.contains('on')) sync(); } };
        if (im.complete) fix(); else im.addEventListener('load', fix);
      });
      if ('MutationObserver' in window){ try { new MutationObserver(sync).observe(g, { attributes: true, subtree: true, attributeFilter: ['class'] }); } catch(e){} }
      sync();
    });
  }

  function boot(){
    try { counters(); } catch(e){}
    try { cards(); } catch(e){}
    try { gallery(); } catch(e){}
    try { demo(); } catch(e){}
    if ('MutationObserver' in window){
      try { new MutationObserver(function(){ try { cards(); } catch(e){} }).observe(document.body, { childList: true, subtree: true }); } catch(e){}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
